import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers } from "redux";
import { reducer as oidcReducer } from "redux-oidc";
import { reducer as appReducer } from "../App";

export const createRootReducer = (reducers: {}, history: History) =>
  combineReducers({ ...reducers, router: connectRouter(history), app: appReducer, oidc: oidcReducer });
